import { useContext, useCallback } from "react";
import { ListContext } from "context";
import isPromise from "helpers/isPromise";

const useSelectIdAction = function (action: (id: unknown) => unknown) {
    const listContext = useContext(ListContext);

    const callback = useCallback(async () => {
        listContext.setLoading(true);
        const returnAction = action(listContext.selectedId);
        if (isPromise(returnAction)) {
            await returnAction;
        }
        listContext.setLoading(false);
        listContext.refreshData();
        listContext.setSelectedId(undefined);
    }, [listContext, action]);

    return callback;
};

export default useSelectIdAction;
